import BaseValidator from '@/lib/data/validator/BaseValidator'

export default class HedgingCarryInputValidator extends BaseValidator {
  validatorRules = {}

  validatorMessages = {
    el: {},
    en: {}
  }

  constructor (data = {}) {
    super(data)
  }
}
